<template>
  <div class="message-main" :style="{'background-color': msgType.bgColor, color: msgType.color}">
    <van-icon :name="msgType.icon" :color="msgType.color" size="60"/>
    <h2 class="title">{{title}}</h2>
    <slot class="desc"></slot>
  </div>
</template>

<script>
import { Icon } from 'vant'

const messageType = {
  success : {
    icon: 'checked',
    bgColor: '#1cb841',
    color: 'white'
  },
  fail : {
    icon: 'clear',
    bgColor: 'orange',
    color: 'white'
  },
  question : {
    icon:'question-o',
    bgColor: 'orange',
    color: 'white'
  }
}

export default {
  name: 'MessageHead',
  props: {
    type: String,
    title: String
  },
  data() {
    return {
      showKeyBoard: false
    }
  },
  components: {
    [Icon.name] : Icon
  },
  methods: {
  },
  computed: {
    msgType() {
      return messageType[this.type] || {}
    }
  }
}
</script>
<style lang="less" scoped>
  .message-main {
    text-align: center;
    padding: 20px 10px;
  }
  .title {
    font-weight: normal;
    font-size: 28px;
    margin-top: 16px;
    margin-bottom: 5px;
  }
  .desc {
    font-size: 12px;
  }
</style>